import { unreachable } from 'utils/unreachable';
import type { FilterFunction } from './filter-functions/types';

export enum QueryCombinerType {
  Any = 'any',
  All = 'all',
}

export const getReducer =
  (type: QueryCombinerType) =>
  (previous: FilterFunction, current: FilterFunction): FilterFunction =>
  (record: Record<string, unknown>): boolean => {
    switch (type) {
      case QueryCombinerType.Any:
        return previous(record) || current(record);
      case QueryCombinerType.All:
        return previous(record) && current(record);
      default:
        return unreachable(type);
    }
  };

export const getSeed = (type: QueryCombinerType): FilterFunction => {
  switch (type) {
    case QueryCombinerType.Any:
      return () => false;
    case QueryCombinerType.All:
      return () => true;
    default:
      return unreachable(type);
  }
};

// TODO: Use translation strings
export const text = (index: number, type: QueryCombinerType) => {
  switch (index) {
    case 0:
      return 'Where';
    default:
      switch (type) {
        case QueryCombinerType.Any:
          return 'Or';
        case QueryCombinerType.All:
          return 'And';
        default:
          return unreachable(type);
      }
  }
};
